import { FC } from "react";
import { UpgradeAccountTypes } from "../../types/upgradeAccount";
import { useNavigate } from "react-router";
import SuccessIcon from "../../assets/icons/SuccessIcon";
import PopUp from "../Popup";
import { useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";

const SuccessPage: FC<UpgradeAccountTypes> = ({ setCurrentStep }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { accountNumber } = useAppSelector((data) => data.stepper.data);

  const isTier3 = searchParams.get("type") === "tier3";

  const navigateHome = () => {
    navigate("/");
  };

  return (
    <PopUp
      icon={<SuccessIcon />}
      title={`Account Upgrade ${isTier3 ? "Request Submitted" : "Successful"}`}
      message={
        isTier3 ? (
          <>
            Your account upgrade request for Account Number -{" "}
            <strong>{accountNumber}</strong> has been submitted, and we are
            presently reviewing. <br /> This usually takes between 48 -72 hours.
            Once approved, your account will be elevated to a Classic Savings
            account.
          </>
        ) : (
          <>
            Your account - <strong>{accountNumber}</strong> has been upgraded to
            a Tier 2 account.
          </>
        )
      }
      cancelText="Okay"
      onClickBtn={navigateHome}
    />
  );
};

export default SuccessPage;
